import QrCode from '../../../../components/QrCode/QrCode'

type QrTabProps = {
  doctorKey: string
}
function QrTab({ doctorKey }: QrTabProps) {
  const qrData = `{uk:'${doctorKey}'}`

  return <QrCode value={qrData} />
}

export default QrTab
